'use client';

import { Box, Container, Text } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import { useLocale } from 'next-intl';
import type { ReactNode } from 'react';
import LanguageSwitcher from '@/components/LanguageChanger';
import classes from './BrandPageShell.module.css';

interface BrandPageShellProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  children: ReactNode;
  contentMaxWidth?: number | string;
}

const DEFAULT_EYEBROW = 'Razee Reset';

export default function BrandPageShell({
  title,
  subtitle,
  eyebrow = DEFAULT_EYEBROW,
  children,
  contentMaxWidth,
}: BrandPageShellProps) {
  const locale = useLocale();
  const homeHref = locale === 'en' ? '/' : `/${locale}`;

  return (
    <Box className={classes.shell}>
      <Container size="xl" className={classes.container}>
        <div className={classes.topBar}>
          <Link href={homeHref} className={classes.homeLink} aria-label="Go to Razee home">
            <Image src="/images/Logo-Header.svg" alt="Razee" width={148} height={36} priority />
          </Link>
          <LanguageSwitcher />
        </div>

        <div className={classes.hero}>
          <Text className={classes.eyebrow}>{eyebrow}</Text>
          <h1 className={classes.title}>{title}</h1>
          {subtitle ? <Text className={classes.subtitle}>{subtitle}</Text> : null}
        </div>

        <Box className={classes.content} maw={contentMaxWidth}>
          {children}
        </Box>
      </Container>
    </Box>
  );
}
